<template>
	<div style="padding-top:100px;">
		<!-- start start screen -->
		<div id="start-screen" style="margin-bottom:0px;" class="start-screen start-screen--style-1" data-scroll-discover="true">
			<div id="start-screen__bg" class="start-screen__bg">
				<div id="vegas-slider" data-dots="true">
					<div class="vegas-control">
						<span id="vegas-control__prev" class="vegas-control__btn">Prev</span>
						<span id="vegas-control__next" class="vegas-control__btn">Next</span>
					</div>
				</div>		
			</div>

			<div id="start-screen__content-container" class="start-screen__content-container  text-white">
				<div class="start-screen__content__item start-screen__content__item--1  align-items-center">
					<div class="container">
						<div class="row justify-content-center">
							<div class="col-12 col-md-10 col-xl-8">
								<div class="__name">SOMOS</div>

								<h2 class="__title text-white">GRUPO ABS</h2>

								<p class="text-center">
									Somos una empresa Mexicana dedicada a la producción, comercialización y distribución de insumos y especialidades de alta calidad para el sector agropecuario.
								</p>

								<input 
								class="search" 
								type="text" 
								name="" 
								placeholder="¿Qué producto estás buscando? (Nombre ó fabricante)" 
								style="width:100%;margin-top: 40px;border-radius:30px;font-size:16px;padding: 16px;border:none;outline: none;padding-left: 32px;"
								v-model="query"
								@keyup.enter="searchProduct"/>
							</div>
						</div>
					</div>
				</div>

				<div class="start-screen__content__item start-screen__content__item--2  align-items-center">
					<div class="container">
						<div class="row align-items-center">
							<div class="col-12 col-md col-lg-9 col-xl-8">
								<div class="__name">AgRO</div>

								<h2 class="__title text-white">Best harvest <br><span>in the World</span></h2>

								<p>
									The point of using Lorem Ipsum is that it has a more-or-less normal distribution
								</p>

								<p class="mt-5 mt-md-10">
									<span class="d-none d-sm-block"><a class="custom-btn custom-btn--big custom-btn--style-3" href="#">Discover</a></span>

									<span class="d-block d-sm-none"><a class="custom-btn custom-btn--small custom-btn--style-3" href="#">Discover</a></span>
								</p>
							</div>

							<div class="col-12 my-3 d-md-none"></div>

							<div class="col-12 col-md-auto col-lg-3 col-xl-4  text-center">
								<a class="play-btn" data-fancybox="" href="http://player.vimeo.com/video/44309170">
									<span></span>
								</a>
							</div>
						</div>
					</div>
				</div>

				<div class="start-screen__content__item start-screen__content__item--3  align-items-center">
					<div class="container">
						<div class="row justify-content-center">
							<div class="col-12 col-md-auto col-xl-8">
								<div class="__name">AgRO</div>

								<h2 class="__title text-white">Live<span style="color: #fcdb5a">stock</span></h2>

								<p class="text-center mt-5 mt-md-10">
									<span class="d-none d-sm-block"><a class="custom-btn custom-btn--big custom-btn--style-3" href="#">Discover</a></span>

									<span class="d-block d-sm-none"><a class="custom-btn custom-btn--small custom-btn--style-3" href="#">Discover</a></span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <span class="scroll-discover"></span> -->
		</div>
		<!-- end start screen -->

		<div>
			<carousel 
			:responsive="{0:{items:2},480:{items:3},767:{items:4},1000:{items:6}}"
			:autoplay="true" 
			:dots="false" 
			:loop="false" 
			:nav="false" 
			style="background-color:#fff;">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/1.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/2.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/3.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/4.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/5.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/6.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/7.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/8.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/9.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/10.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/11.jpg">
			<!-- <img style="width: 100%; padding: 12px;" src="img/carousel_index/12.jpg"> -->
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/13.jpg">
			<img style="width: 100%; padding: 12px;" src="img/carousel_index/14.jpg">
		</carousel>
	</div>


	<!-- start main -->
	<main role="main">
				<!-- Common styles
					================================================== -->
					<!-- <link rel="stylesheet" href="./../assets/style/style.min.css" type="text/css"> -->
					<link rel="stylesheet" type="text/css" href="css/style.min.css">
					<link rel="stylesheet" type="text/css" href="css/vegas.css">

					<!-- start section -->
					<section class="section" style="padding-top:80px;">
						<div class="container">
							<div class="corporate-profile">
								<h2 class="__title">¿QUIÉNES SOMOS?</h2>

								<p class="text-content">Somos una empresa mexicana dedicada a la producción, comercialización y distribución de insumos y especialidades de alta calidad para el sector agropecuario.</p>
								<p class="text-content">Nuestros productos se enfocan al control de plagas, asimilación de nutrientes, protección de las plantas y el mayor rendimiento en la producción agrícola.</p>
							</div>

							<div class="row corporate-profile">
								<div class="col-12 col-lg-6">
									<h2 class="__title">Nuestra <span>Misión</span></h2>

									<p class="text-content">Buscar la excelencia y superación constante de nuestros estándares de calidad y servicio para satisfacer los requerimientos de la agricultura contemporánea.</p>
								</div>
								<div class="col-12 col-lg-6">
									<h2 class="__title">Nuestra <span>Visión</span></h2>

									<p class="text-content">Investigar, producir y comercializar alternativas biotecnológicas para un producción agrícola y pecuaria sostenible, considerando el ecosistema y la interacción de sus componentes.</p>
								</div>
							</div>
						</div>
					</section>
					<!-- end section -->

					<!-- start section -->
					<section class="section section--no-pt section--no-pb section--gutter">

						<div class="container">
							<div class="special-offer special-offer--style-1">
								<!-- <h2 class="text text-center" data-src="img/special_offer_text_bg.jpg">Nuestros productos</h2> -->
								<h1 class="text-center">Nuestros productos</h1>
							</div>
						</div>

						<div class="container-fluid px-md-0">
							<!-- start product preview -->

							<div class="product-preview product-preview--style-1">
								<div class="__inner">
									<div class="row">
										<!-- start item -->
										<!-- <div class="col-12 col-md-7 col-xl-6">
											<div class="__item">
												<div class="__intro-text">
													<div class="row">
														<div class="col-md-11">
															<h2>Grupo ABS<span> productos</span></h2>
														</div>
													</div>
												</div>
											</div>
										</div> -->
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-5 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<!-- <img class="" src="img/product1.jpg" data-src="img/product1.jpg" alt="demo" /> -->
												</figure>

												<div class="__content">
													<h3>Grupo ABS<span> productos</span></h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-5 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="img/tomatoes-1581204.jpg" data-src="img/tomatoes-1581204.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Nematicida</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-5 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="img/leaves-1217677.jpg" data-src="img/leaves-1217677.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Biológicos</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-4 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="./../assets/img/zucchini-847094.jpg" data-src="./../assets/img/zucchini-847094.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Fungicida</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-4 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="./../assets/img/bell-peppers-2708680.jpg" data-src="./../assets/img/bell-peppers-2708680.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Bactericida</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-4 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="./../assets/img/pepper-crop-61720.jpg" data-src="./../assets/img/pepper-crop-61720.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Insecticida</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-4 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="./../assets/img/tomato-3919426.jpg" data-src="./../assets/img/tomato-3919426.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Nutrición</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

										<!-- start item -->
										<div class="col-12 col-md-4 col-xl-3">
											<div class="__item">
												<figure class="__image">
													<img class="" src="./../assets/img/potato-3689642.jpg" data-src="./../assets/img/potato-3689642.jpg" alt="demo" />
												</figure>

												<div class="__content">
													<h3 class="__title" style="color:#FFF">Otros</h3>
												</div>

												<router-link
												class="__link"
												tag="a"
												to="/productos"
												></router-link>

												<!-- <a class="__link" href="#"></a> -->
											</div>
										</div>
										<!-- end item -->

									</div>
								</div>
							</div>
							<!-- end product preview -->
						</div>
					</section>
					<!-- end section -->

					<!-- start section -->
					<section class="section">
						<div class="container">
							<div class="section-heading section-heading--center">
								<h2 class="__title">Donde necesites <span>efectividad</span></h2>

								<p class="text-content">Ahí estaremos para atenderte, con toda la calidad que nos distingue.</p>
							</div>

          <!-- <div>
            <img class="img-fluid" src="./../assets/img/img_country_map.png" alt="demo" />
        </div> -->


        <div>
        	<div class="modal-sucursal container boxsu" style="background-color: #f1f1f1;opacity: 0.8;padding:20px;">
        		<a href="##" onclick="$('.modal-sucursal').hide('fast');" id="close">
        			<i class="fa fa-close" aria-hidden="true"></i>
        		</a>
        		<div class="col-xs-12" align="left">
        			<h4 id="sucursal" class="sucursal">
        				Culiacán
        			</h4>
        			<p id="dir" class="dir">
        				Calle Industrial 4 Lote 44B, La Primavera, Culiacán, Sinaloa. C.P. 80199
        			</p>
        			<p id="contact-person" class="contact-person">
        				Persona de contacto: Hugo Felix
        			</p>
        			<p id="contact-email" class="contact-email">
        				Correo electrónico: ventas@agrobiosol.com.mx
        			</p>
        			<p id="contact-phone" class="contact-phone">
        				Teléfono de oficina: (668) 811-87-00
        			</p>

        		</div>
        	</div>
        	<img id="map" class="img-responsive" data-animation="animated fadeInRight" src="./../assets/img/img_country_map.png" alt="#" style="margin-left: 15.5%;width: 65%;" usemap="#mapa">
        	<map id="mapa" name="mapa">
        		<area coords="670,755,30" shape="circle" alt="1">
              <area coords="716,853,30" shape="circle" alt="2">
              <area coords="625,685,30" shape="circle" alt="3">
              <area coords="596,639,30" shape="circle" alt="4">
              <area coords="844,1131,30" shape="circle" alt="5">
              <area coords="1010,577,30" shape="circle" alt="6">
              <area coords="450,407,30" shape="circle" alt="7">
              <area coords="170,64,30" shape="circle" alt="8">
              <area coords="152,261,30" shape="circle" alt="9">
              <area coords="349,587,30" shape="circle" alt="10">
              <area coords="448,801,30" shape="circle" alt="11">
              <area coords="679,787,30" shape="circle" alt="12">            
        	</map>

        </div>

    </div>
</section>
<!-- end section -->

<Contact />
</main>
<!-- end main -->
</div>
</template>

<script>
import Map from '@/components/Map.vue'
import Contact from '@/components/Contact.vue'
import router from '@/router'
import carousel from 'vue-owl-carousel'
import axios from 'axios'

export default {
	data () {
		return {
			query: ''
		}
	},
	name: 'home',
	components: {
		Map,
		Contact,
		carousel
	},
	methods: {
		searchProduct () {
			var vm = this
			this.$store.dispatch('search', this.query)
			axios.get('/product/products?query=' + this.query)
			.then(res => {
				console.log(res.data.products)
				let products = res.data.products
				console.log(products[0].type)
				if (products[0].type === 'Otros productos') {
					router.replace('/productos#appProducts')
				} else {
					router.replace('/productos_premium#appProducts')
				}
			})
			.catch(err => console.log(err))

			// router.replace('/productos_premium#appProducts')
		}
	},
	mounted () {
		(function()
		{
			var oInterval = setInterval(function ()
			{
				if (typeof window.jQuery !== 'undefined')
				{
					clearInterval(oInterval);

									/*!-----------------------------------------------------------------------------
									 * Vegas - Fullscreen Backgrounds and Slideshows.
									 * v2.3.1 - built 2016-09-18
									 * Licensed under the MIT License.
									 * http://vegas.jaysalvat.com/
									 * ----------------------------------------------------------------------------
									 * Copyright (C) 2010-2016 Jay Salvat
									 * http://jaysalvat.com/
									 * --------------------------------------------------------------------------*/
									 !function(t){"use strict";var s={slide:0,delay:5e3,loop:!0,preload:!1,preloadImage:!1,preloadVideo:!1,timer:!0,overlay:!1,autoplay:!0,shuffle:!1,cover:!0,color:null,align:"center",valign:"center",firstTransition:null,firstTransitionDuration:null,transition:"fade",transitionDuration:1e3,transitionRegister:[],animation:null,animationDuration:"auto",animationRegister:[],init:function(){},play:function(){},pause:function(){},walk:function(){},slides:[]},i={},e=function(i,e){this.elmt=i,this.settings=t.extend({},s,t.vegas.defaults,e),this.slide=this.settings.slide,this.total=this.settings.slides.length,this.noshow=this.total<2,this.paused=!this.settings.autoplay||this.noshow,this.ended=!1,this.$elmt=t(i),this.$timer=null,this.$overlay=null,this.$slide=null,this.timeout=null,this.first=!0,this.transitions=["fade","fade2","blur","blur2","flash","flash2","negative","negative2","burn","burn2","slideLeft","slideLeft2","slideRight","slideRight2","slideUp","slideUp2","slideDown","slideDown2","zoomIn","zoomIn2","zoomOut","zoomOut2","swirlLeft","swirlLeft2","swirlRight","swirlRight2"],this.animations=["kenburns","kenburnsLeft","kenburnsRight","kenburnsUp","kenburnsUpLeft","kenburnsUpRight","kenburnsDown","kenburnsDownLeft","kenburnsDownRight"],this.settings.transitionRegister instanceof Array==!1&&(this.settings.transitionRegister=[this.settings.transitionRegister]),this.settings.animationRegister instanceof Array==!1&&(this.settings.animationRegister=[this.settings.animationRegister]),this.transitions=this.transitions.concat(this.settings.transitionRegister),this.animations=this.animations.concat(this.settings.animationRegister),this.support={objectFit:"objectFit"in document.body.style,transition:"transition"in document.body.style||"WebkitTransition"in document.body.style,video:t.vegas.isVideoCompatible()},this.settings.shuffle===!0&&this.shuffle(),this._init()};e.prototype={_init:function(){var s,i,e,n="BODY"===this.elmt.tagName,o=this.settings.timer,a=this.settings.overlay,r=this;this._preload(),n||(this.$elmt.css("height",this.$elmt.css("height")),s=t('<div class="vegas-wrapper">').css("overflow",this.$elmt.css("overflow")).css("padding",this.$elmt.css("padding")),this.$elmt.css("padding")||s.css("padding-top",this.$elmt.css("padding-top")).css("padding-bottom",this.$elmt.css("padding-bottom")).css("padding-left",this.$elmt.css("padding-left")).css("padding-right",this.$elmt.css("padding-right")),this.$elmt.clone(!0).children().appendTo(s),this.elmt.innerHTML=""),o&&this.support.transition&&(e=t('<div class="vegas-timer"><div class="vegas-timer-progress">'),this.$timer=e,this.$elmt.prepend(e)),a&&(i=t('<div class="vegas-overlay">'),"string"==typeof a&&i.css("background-image","url("+a+")"),this.$overlay=i,this.$elmt.prepend(i)),this.$elmt.addClass("vegas-container"),n||this.$elmt.append(s),setTimeout(function(){r.trigger("init"),r._goto(r.slide),r.settings.autoplay&&r.trigger("play")},1)},_preload:function(){var t,s;for(s=0;s<this.settings.slides.length;s++)(this.settings.preload||this.settings.preloadImages)&&this.settings.slides[s].src&&(t=new Image,t.src=this.settings.slides[s].src),(this.settings.preload||this.settings.preloadVideos)&&this.support.video&&this.settings.slides[s].video&&(this.settings.slides[s].video instanceof Array?this._video(this.settings.slides[s].video):this._video(this.settings.slides[s].video.src))},_random:function(t){return t[Math.floor(Math.random()*t.length)]},_slideShow:function(){var t=this;this.total>1&&!this.ended&&!this.paused&&!this.noshow&&(this.timeout=setTimeout(function(){t.next()},this._options("delay")))},_timer:function(t){var s=this;clearTimeout(this.timeout),this.$timer&&(this.$timer.removeClass("vegas-timer-running").find("div").css("transition-duration","0ms"),this.ended||this.paused||this.noshow||t&&setTimeout(function(){s.$timer.addClass("vegas-timer-running").find("div").css("transition-duration",s._options("delay")-100+"ms")},100))},_video:function(t){var s,e,n=t.toString();return i[n]?i[n]:(t instanceof Array==!1&&(t=[t]),s=document.createElement("video"),s.preload=!0,t.forEach(function(t){e=document.createElement("source"),e.src=t,s.appendChild(e)}),i[n]=s,s)},_fadeOutSound:function(t,s){var i=this,e=s/10,n=t.volume-.09;n>0?(t.volume=n,setTimeout(function(){i._fadeOutSound(t,s)},e)):t.pause()},_fadeInSound:function(t,s){var i=this,e=s/10,n=t.volume+.09;1>n&&(t.volume=n,setTimeout(function(){i._fadeInSound(t,s)},e))},_options:function(t,s){return void 0===s&&(s=this.slide),void 0!==this.settings.slides[s][t]?this.settings.slides[s][t]:this.settings[t]},_goto:function(s){function i(){f._timer(!0),setTimeout(function(){y&&(f.support.transition?(h.css("transition","all "+_+"ms").addClass("vegas-transition-"+y+"-out"),h.each(function(){var t=h.find("video").get(0);t&&(t.volume=1,f._fadeOutSound(t,_))}),e.css("transition","all "+_+"ms").addClass("vegas-transition-"+y+"-in")):e.fadeIn(_));for(var t=0;t<h.length-4;t++)h.eq(t).remove();f.trigger("walk"),f._slideShow()},100)}"undefined"==typeof this.settings.slides[s]&&(s=0),this.slide=s;var e,n,o,a,r,h=this.$elmt.children(".vegas-slide"),d=this.settings.slides[s].src,l=this.settings.slides[s].video,g=this._options("delay"),u=this._options("align"),c=this._options("valign"),p=this._options("cover"),m=this._options("color")||this.$elmt.css("background-color"),f=this,v=h.length,y=this._options("transition"),_=this._options("transitionDuration"),w=this._options("animation"),b=this._options("animationDuration");this.settings.firstTransition&&this.first&&(y=this.settings.firstTransition||y),this.settings.firstTransitionDuration&&this.first&&(_=this.settings.firstTransitionDuration||_),this.first&&(this.first=!1),"repeat"!==p&&(p===!0?p="cover":p===!1&&(p="contain")),("random"===y||y instanceof Array)&&(y=y instanceof Array?this._random(y):this._random(this.transitions)),("random"===w||w instanceof Array)&&(w=w instanceof Array?this._random(w):this._random(this.animations)),("auto"===_||_>g)&&(_=g),"auto"===b&&(b=g),e=t('<div class="vegas-slide"></div>'),this.support.transition&&y&&e.addClass("vegas-transition-"+y),this.support.video&&l?(a=l instanceof Array?this._video(l):this._video(l.src),a.loop=void 0!==l.loop?l.loop:!0,a.muted=void 0!==l.mute?l.mute:!0,a.muted===!1?(a.volume=0,this._fadeInSound(a,_)):a.pause(),o=t(a).addClass("vegas-video").css("background-color",m),this.support.objectFit?o.css("object-position",u+" "+c).css("object-fit",p).css("width","100%").css("height","100%"):"contain"===p&&o.css("width","100%").css("height","100%"),e.append(o)):(r=new Image,n=t('<div class="vegas-slide-inner"></div>').css("background-image",'url("'+d+'")').css("background-color",m).css("background-position",u+" "+c),"repeat"===p?n.css("background-repeat","repeat"):n.css("background-size",p),this.support.transition&&w&&n.addClass("vegas-animation-"+w).css("animation-duration",b+"ms"),e.append(n)),this.support.transition||e.css("display","none"),v?h.eq(v-1).after(e):this.$elmt.prepend(e),h.css("transition","all 0ms").each(function(){this.className="vegas-slide","VIDEO"===this.tagName&&(this.className+=" vegas-video"),y&&(this.className+=" vegas-transition-"+y,this.className+=" vegas-transition-"+y+"-in")}),f._timer(!1),a?(4===a.readyState&&(a.currentTime=0),a.play(),i()):(r.src=d,r.complete?i():r.onload=i)},_end:function(){this.ended=!0,this._timer(!1),this.trigger("end")},shuffle:function(){for(var t,s,i=this.total-1;i>0;i--)s=Math.floor(Math.random()*(i+1)),t=this.settings.slides[i],this.settings.slides[i]=this.settings.slides[s],this.settings.slides[s]=t},play:function(){this.paused&&(this.paused=!1,this.next(),this.trigger("play"))},pause:function(){this._timer(!1),this.paused=!0,this.trigger("pause")},toggle:function(){this.paused?this.play():this.pause()},playing:function(){return!this.paused&&!this.noshow},current:function(t){return t?{slide:this.slide,data:this.settings.slides[this.slide]}:this.slide},jump:function(t){0>t||t>this.total-1||t===this.slide||(this.slide=t,this._goto(this.slide))},next:function(){if(this.slide++,this.slide>=this.total){if(!this.settings.loop)return this._end();this.slide=0}this._goto(this.slide)},previous:function(){if(this.slide--,this.slide<0){if(!this.settings.loop)return void this.slide++;this.slide=this.total-1}this._goto(this.slide)},trigger:function(t){var s=[];s="init"===t?[this.settings]:[this.slide,this.settings.slides[this.slide]],this.$elmt.trigger("vegas"+t,s),"function"==typeof this.settings[t]&&this.settings[t].apply(this.$elmt,s)},options:function(i,e){var n=this.settings.slides.slice();if("object"==typeof i)this.settings=t.extend({},s,t.vegas.defaults,i);else{if("string"!=typeof i)return this.settings;if(void 0===e)return this.settings[i];this.settings[i]=e}this.settings.slides!==n&&(this.total=this.settings.slides.length,this.noshow=this.total<2,this._preload())},destroy:function(){clearTimeout(this.timeout),this.$elmt.removeClass("vegas-container"),this.$elmt.find("> .vegas-slide").remove(),this.$elmt.find("> .vegas-wrapper").clone(!0).children().appendTo(this.$elmt),this.$elmt.find("> .vegas-wrapper").remove(),this.settings.timer&&this.$timer.remove(),this.settings.overlay&&this.$overlay.remove(),this.elmt._vegas=null}},t.fn.vegas=function(t){var s,i=arguments,n=!1;if(void 0===t||"object"==typeof t)return this.each(function(){this._vegas||(this._vegas=new e(this,t))});if("string"==typeof t){if(this.each(function(){var e=this._vegas;if(!e)throw new Error("No Vegas applied to this element.");"function"==typeof e[t]&&"_"!==t[0]?s=e[t].apply(e,[].slice.call(i,1)):n=!0}),n)throw new Error('No method "'+t+'" in Vegas.');return void 0!==s?s:this}},t.vegas={},t.vegas.defaults=s,t.vegas.isVideoCompatible=function(){return!/(Android|webOS|Phone|iPad|iPod|BlackBerry|Windows Phone)/i.test(navigator.userAgent)}}(window.jQuery||window.Zepto);

									 jQuery(document).ready(function($){

									 	var slider = $('#vegas-slider'),
									 	slides = [
									 	{
									 		name: "img 1",
									 		src: 'img/home_img/img_1.jpg'
									 	}
									 	],
									 	slider_content = $('.start-screen__content__item'),
									 	dots, a, x;

									 	slider.vegas({
									 		autoplay: false,
									 		timer: false,
									 		preloadImage: true,
									 		transition: [ 'fade', 'zoomOut', 'blur', 'swirlLeft', 'swirlRight' ],
									 		transitionDuration: 4000,
									 		delay: 5000,
									 		slides: slides,
									 		overlay: 'img/home_img/overlays/05.png',
									 		init: function (globalSettings) {

									 			if ( this.data('dots') == true ) {

									 				var $this = this,
									 				dots = $('<nav class="vegas-dots"></nav>');

									 				$this.find('.vegas-control').append(dots);

									 				// for (var i = 0; i < slides.length; i++) {
									 				// 	x = $('<a "href="#" class="paginatorLink"></a>');

									 				// 	x.on('click', function(e) {
									 				// 		e.preventDefault();

									 				// 		$this.vegas('jump', dots.find('a').index(this));
									 				// 	});

									 				// 	dots.append(x);
									 				// };

									 				a = dots.find('a');
									 				a.eq(0).addClass('active');

									 				slider_content.eq(0).addClass('is-active');
									 			};
									 		},
									 		play: function (index, slideSettings) {
									 			
									 		},
									 		walk: function (index, slideSettings) {

									 			if ( this.data('dots') == true ) {

									 				a.removeClass('active').eq(index).addClass('active');
									 			};

									 			slider_content.removeClass('is-active').eq(index).addClass('is-active');
									 		}
									 	});

									 	$('#vegas-control__prev').on('click', function () {
									 		slider.vegas('previous');
									 	});

									 	$('#vegas-control__next').on('click', function () {
									 		slider.vegas('next');
									 	});
									 });
									}
								}, 500);
})();

$(document).ready(function (e) {

	$('#test').css('color', 'red')

	$('img[usemap]').rwdImageMaps();

	$('area').on('click', function () {
		console.log($(this).attr('alt'));

		$("#numap").text($(this).attr('alt'));
		$(".modal-sucursal").hide("fast");
		$(".modal-sucursal").show("fast");

		switch ($(this).attr('alt')) {
			case "1":
			$(".sucursal").text("Culiacán");
			$(".dir").html("Calle Industrial 4 Lote 44B, La Primavera, Culiacán, Sinaloa. C.P. 80199");
			$(".contact-person").html("Persona de contacto: Hugo Felix");
			$(".contact-email").html("Correo electrónico: ventas@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (667) 760-37-40");
			break;

			case "2":
			$(".sucursal").text("El Rosario");
			$(".dir").html("Callejon Santa Simona 10, Col. Centro, El Rosario, Sinaloa. C.P. 82800");
			$(".contact-person").html("Persona de contacto: Cesar Leon");
			$(".contact-email").html("Correo electrónico: ing.rendon@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (694) 952-01-93");
			break;

			case "3":
			$(".sucursal").text("Guasave");
			$(".dir").html("Calle Nuevo Leon S/N entre Av. Cuitzeo y Manzana 20, Col. Stase, Guasave, Sinaloa. C.P. 81029");
			$(".contact-person").html("Persona de contacto: Ricardo Luna");
			$(".contact-email").html("Correo electrónico: ventas.guasave@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (687) 871-38-83");
			break;
			case "4":
			$(".sucursal").text("Los Mochis");
			$(".dir").html("Blvd. Adolfo Lopez Mateos 3306, Col. Miguel Hidalgo, Los Mochis Ahome, Sinaloa. C.P. 81210");
			$(".contact-person").html("Persona de contacto: Mauricio Roman");
			$(".contact-email").html("Correo electrónico: ventas.mochis@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (668) 811-87-00");
			break;
			case "5":
			$(".sucursal").text("Cd. Guzmán");
			$(".dir").html("Bloque A, Bodega 8, Central de Abastos, Ciudad Guzmán, Zapotlan el Grande, Jalisco. C.P. 49000");
			$(".contact-person").html("Persona de contacto: José Orozco");
			$(".contact-email").html("Correo electrónico: admin.cdguzman@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (341) 410-69-32");
			break;
			case "6":
			$(".sucursal").text("Torreón");
			$(".dir").html("Antigua Carretera San Pedro 765 Bodega 10, Col. Paso del Aguila, Torreón, Coahuila. C.P. 27410");
			$(".contact-person").html("Persona de contacto: José Humberto Garcia");
			$(".contact-email").html("Correo electrónico: jhgarcia@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (871) 688-21-88");
			break;
			case "7":
			$(".sucursal").text("Ciudad Obregón");
			$(".dir").html("Dr. Norman E. Borlaug 6917 sur, Col. El Roble, Cd. Obregón, Sonora. C.P. 85190");
			$(".contact-person").html("Persona de contacto: Ing. Martin Méndez");
			$(".contact-email").html("Correo electrónico: ing.mendez@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (644) 204-12-74");
			break;
			case "8":
			$(".sucursal").text("Mexicali");
			$(".dir").html("Lazaro Cardenas Local 4X, Ejido Hermosillo, Baja California. C.P. 21840");
			$(".contact-person").html("Persona de contacto: Mauricio Tolosa");
			$(".contact-email").html("Correo electrónico: ing.tolosa@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (686) 220-62-21");
			break;
			case "9":
			$(".sucursal").text("Camalú");
			$(".dir").html("Calle Benito Juarez 1702, Col. Zuñiga, Camalu Ensenada, B.C. C.P 22910");
			$(".contact-person").html("Persona de contacto: Jesus Jacobo");
			$(".contact-email").html("Correo electrónico: jhgarcia@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (116) 165-55-75");
			break;
			case "10":
			$(".sucursal").text("Cd. Constitución");
			$(".dir").html("Carretera Transpeninsular KM 212, Col. Vargas, Cd. Constitución, BCS. C.P. 23630");
			$(".contact-person").html("Persona de contacto: Gibran Perez");
			$(".contact-email").html("Correo electrónico: ing.perez@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (613) 111-02-98");
			break;
			case "11":
			$(".sucursal").text("La Paz");
			$(".dir").html("Blvd. Forjadores De SudCalifornia, Carretera al sur km 7, Local 1, Col. Tabachines, La Paz, BCS. C.P. 23084");
			$(".contact-person").html("Persona de contacto: Luis Quintero");
			$(".contact-email").html("Correo electrónico: admin.lapaz@agrobiosol.com.mx");
			$(".contact-phone").html("Teléfono de oficina: (612) 121-44-26");
			break;
			case "12":
                $(".sucursal").text("La Cruz, Elota");
                $(".dir").html("Carretera La Cruz-Culiacán Km 1.25 Plaza Montebello Local #14");
                $(".contact-person").html("Persona de contacto: Ing. Guadalupe Perea");
                $(".contact-email").html("Correo electrónico: ventas.lacruz@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (667) 503-39-85");
                break;
		}
	});
});

/*
* rwdImageMaps jQuery plugin v1.6
*
* Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
*
* Copyright (c) 2016 Matt Stow
* https://github.com/stowball/jQuery-rwdImageMaps
* http://mattstow.com
* Licensed under the MIT license
*/
;(function($) {
	$.fn.rwdImageMaps = function() {
		var $img = this;

		var rwdImageMap = function() {
			$img.each(function() {
				if (typeof($(this).attr('usemap')) == 'undefined')
					return;

				var that = this,
				$that = $(that);

        // Since WebKit doesn't know the height until after the image has loaded, perform everything in an onload copy
        $('<img />').on('load', function() {
        	var attrW = 'width',
        	attrH = 'height',
        	w = $that.attr(attrW),
        	h = $that.attr(attrH);

        	if (!w || !h) {
        		var temp = new Image();
        		temp.src = $that.attr('src');
        		if (!w)
        			w = temp.width;
        		if (!h)
        			h = temp.height;
        	}

        	var wPercent = $that.width()/100,
        	hPercent = $that.height()/100,
        	map = $that.attr('usemap').replace('#', ''),
        	c = 'coords';

        	$('map[name="' + map + '"]').find('area').each(function() {
        		var $this = $(this);
        		if (!$this.data(c))
        			$this.data(c, $this.attr(c));

        		var coords = $this.data(c).split(','),
        		coordsPercent = new Array(coords.length);

        		for (var i = 0; i < coordsPercent.length; ++i) {
        			if (i % 2 === 0)
        				coordsPercent[i] = parseInt(((coords[i]/w)*100)*wPercent);
        			else
        				coordsPercent[i] = parseInt(((coords[i]/h)*100)*hPercent);
        		}
        		$this.attr(c, coordsPercent.toString());
        	});
        }).attr('src', $that.attr('src'));
    });
		};
		$(window).resize(rwdImageMap).trigger('resize');

		return this;
	};
})(jQuery);

}
};
</script>

<style scoped>
.modal-sucursal {
	position: absolute;
	margin-top: 0%;
	left: 52% !important;
	width: 45% !important;
}
</style>
